export default __webpack_public_path__ + "static/media/ndsp-logo.cb80147f.svg";